import { inject, Injectable } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'
import { FilesizePipe } from './filesize.pipe'
import { ToastService } from './toast.service'
import { getFileExtension } from './utils'

export type FileValidationFailureReason = 'invalid_file_type' | 'file_too_large'

@Injectable({
  providedIn: 'root',
})
export class FileValidationService {
  private toastService = inject(ToastService)
  private translateService = inject(TranslateService)
  private fileSizePipe = new FilesizePipe()

  validateFile(file: File, acceptedTypes: string[], maxSize: number | null): FileValidationFailureReason | null {
    const extension = getFileExtension(file)

    if (!acceptedTypes.includes(extension)) {
      const fileTypes = acceptedTypes.map((type) => type.toUpperCase()).join(', ')
      const error = this.translateService.instant('CALLS.CALL_INFO.DOCUMENT_UPLOAD.INVALID_FILE_TYPE', { fileTypes })
      this.toastService.showRaw(error)
      return 'invalid_file_type'
    }
    if (maxSize !== null && file.size > maxSize) {
      const error = this.translateService.instant('CALLS.CALL_INFO.DOCUMENT_UPLOAD.FILE_TOO_LARGE', {
        maxSize: this.fileSizePipe.transform(maxSize),
      })
      this.toastService.showRaw(error)
      return 'file_too_large'
    }
    return null
  }

  validateFiles(files: File[], acceptedTypes: string[], maxSize: number | null): File[] {
    return files.filter((file) => this.validateFile(file, acceptedTypes, maxSize) === null)
  }
}
